// src/modules/app-views/offers/pages/Init/components/tableColumns/nameColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function nameColumn(buildColumnProps, options = {}) {
  const {
    key = 'name',
    title = 'name',
    dataIndex = 'name',
    width = 200,
    align = 'left',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const name = r?.name;
      return name ? <span className="font-weight-bold">{name}</span> : '—';
    },
  };
}

export default nameColumn;
